import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetExchangeDataRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetExchangeDataResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getExchangeData = (request: GetExchangeDataRequest, options?: CashRequestOptions) =>
  post<GetExchangeDataRequest, GetExchangeDataResponse>('/2.0/cash/get-exchange-data', request, {
    ...options,
    rejectOnError: true,
  })
